<template>
  <div ref="layout" class="page-form">
    <h3 class="title">客户信息新增</h3>

    <div class="container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
      <template v-if="clientData !== null">
        <base-info-add
          ref="info"
          :client-data="clientData"
        >
          <template #bank>
            <bank-info-add ref="bank" :bank="clientData.BANK" @update:bank="handleBankUpdate" />
          </template>
        </base-info-add>
      </template>
    </div>
  </div>
</template>

<script>
import BaseInfoAdd from './components/BaseInfoAdd.vue'
import BankInfoAdd from './components/BankInfoAdd.vue'

import { clientCreate } from '@/api/sap/client-sap'

export default {
  name: 'client-add',
  components: { BaseInfoAdd, BankInfoAdd },
  data() {
    return {
      loading: false,
      clientData: null
    }
  },
  created() {
    this.initClientData()
  },
  methods: {
    initClientData() {
      this.clientData = this.getDefaultClientData()
      this.loading = false
    },
    getDefaultClientData() {
      return {
        INFO: {},
        TAX: {},
        YXDY: [],
        ADDRESS: [],
        HISTORY: {},
        PRO: [],
        TYPE_HISTORY: [],
        approve: {},
        ROLES: [],
        RELATION: [],
        BANK: []
      }
    },
    handleBankUpdate(bankData) {
      this.clientData.BANK = bankData
    },
    async saveData() {
      const info = this.$refs.info.submitForm()
      if (!info) return
      const ROLES = []
      const RELATION = []
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...info,
        RELATION,
        ROLES,
        BANK: this.clientData.BANK
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const { MSGTYPE, MESSAGE } = await clientCreate(params)
        if (MSGTYPE === 'S') {
          this.$message.success(MESSAGE || '保存成功')
          this.resetForm()
        } else {
          this.$message.error(MESSAGE)
        }
      } catch (e) {
        //
      }

      this.$nextTick(() => {
        loading.close()
      })
    },
    resetForm() {
      this.initClientData()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0 48px;
}
</style>





// WEBPACK FOOTER //
// src/views/client-manage/clientAdd.vue